import { render } from "./AdminAppLayout.vue?vue&type=template&id=51d4a792&scoped=true"
import script from "./AdminAppLayout.vue?vue&type=script&lang=js"
export * from "./AdminAppLayout.vue?vue&type=script&lang=js"

import "./AdminAppLayout.vue?vue&type=style&index=0&id=51d4a792&scoped=true&lang=css"
import "./AdminAppLayout.vue?vue&type=style&index=1&id=51d4a792&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51d4a792"]])

export default __exports__